import { tableStyle } from '@bingads-webui-campaign-react/common-styles';

export const getImportTableOverrideStyle = ({ palette = {} }) => ({
  '& table': {
    ...tableStyle({ palette })['& .table'],
    marginBottom: 0,

    '& thead>tr>th': {
      borderBottom: '2px solid #81868B !important',
      borderTop: '2px solid #81868B !important',
      lineHeight: 1.5,
      padding: 8,

      '& .grid-header-text': {
        display: 'inline',
      },

      '& input[type="checkbox"].select-all:focus': {
        outline: `1px solid ${palette.neutralSecondary} !important`,
      },
    },

    '& tbody>tr>td': {
      padding: 8,

      '&>p': {
        margin: 0,
      },

      '& input[type="checkbox"].select-row:focus': {
        outline: `1px solid ${palette.neutralSecondary} !important`,
      },
    },

    '& tbody>tr:hover': {
      backgroundColor: palette.neutralLighter,
    },
  },
});
